import {HelpButtonProps} from '../components/helpButton/HelpButton';

export enum HelpTutorialEnum {
  // feature
  ETSY_SEO_OPTIMIZATION = 'etsy-seo-optimization',
  ETSY_PRODUCT_UPLOAD = 'etsy-product-upload',
  ETSY_BULK_UPDATE_LISTINGS_WITH_CSV = 'etsy-bulk-update-listings-with-csv',
  ETSY_BULK_UPDATE_GOOGLE_SHEET = 'etsy-bulk-update-google-sheet',
  ETSY_BULK_CREATE_LISTINGS_WITH_CSV = 'etsy-bulk-create-listings-with-csv',
  ETSY_BULK_CREATE_LISTINGS_WITH_GDRIVE_FILE = 'etsy-bulk-create-listings-with-gdrive-file',
  ETSY_BULK_CREATE_LISTINGS_WITH_GDRIVE_FOLDER = 'etsy-bulk-create-listings-with-gdrive-folder',
  ETSY_COPY_LISTING = 'etsy-copy-listing',

  // general help
  SHOW_JOB_LIST = 'show-job-list',

  // general etsy function
  ETSY_CREATE_TEMPLATE = 'etsy-create-template',
  ETSY_LINK_ACCOUNT = 'etsy-link-account',

  // GDRIVE
  GDRIVE_CREATE_SHARE_LINK = 'gdrive-create-share-link',
}

export const helpTutorialMap: Record<HelpTutorialEnum, HelpButtonProps> = {
  [HelpTutorialEnum.ETSY_SEO_OPTIMIZATION]: {
    title: 'SEO optimisation',
    description:
      'SEO optimization is the process of optimizing your listings to improve their visibility in search results. This includes optimizing the title, description, and tags of your listings.',
    videoUrl: 'https://youtu.be/TR596Fv0pFo',
  },
  [HelpTutorialEnum.ETSY_PRODUCT_UPLOAD]: {
    title: 'Product Upload with optional pdf generation',
    description:
      'Used for adding single new listing. Works for physical and digital products. Optional PDF generation is supported for digital files.',
    videoUrl: 'https://youtu.be/ryDQdUgW_5w',
  },
  [HelpTutorialEnum.ETSY_BULK_CREATE_LISTINGS_WITH_CSV]: {
    description: 'Bulk create listings from a CSV file. This is only for creating new listings',
    title: 'Bulk Create Listings with CSV',
    videoUrl: 'https://youtu.be/f7wmfNhCpbE',
  },
  [HelpTutorialEnum.ETSY_BULK_UPDATE_LISTINGS_WITH_CSV]: {
    title: 'Bulk Update Listings with CSV',
    description: 'Bulk update listings from a CSV file. This is only for updating existing listings',
    videoUrl: 'https://youtu.be/ydUe5Htr7XE',
  },
  [HelpTutorialEnum.ETSY_BULK_UPDATE_GOOGLE_SHEET]: {
    title: 'Bulk Update Listings with Google Sheet',
    description:
      'Link an Etsy store and a Google Sheet, then export listings to the sheet or update Etsy from the sheet. Columns: listingId, title, tags, description, favourite, view, last update.',
  },
  [HelpTutorialEnum.ETSY_BULK_CREATE_LISTINGS_WITH_GDRIVE_FILE]: {
    title: 'Bulk Create Listings with Google Drive File',
    description:
      'Paste a Google Drive folder shared link and pick the files you need from the folder. Each selected file is uploaded as an Etsy listing, with a matching digital product file attached.',
    videoUrl: 'https://youtu.be/IHd0TQePwqE',
  },
  [HelpTutorialEnum.ETSY_BULK_CREATE_LISTINGS_WITH_GDRIVE_FOLDER]: {
    title: 'Bulk Create Listings with Google Drive Folder',
    description:
      'Connect your Google Drive, select one or more folder(s), and automatically upload its contents as Etsy listings. Each folder is considered as a listing.',
    videoUrl: 'https://youtu.be/1ZvGbufJCGk',
  },
  [HelpTutorialEnum.ETSY_COPY_LISTING]: {
    title: 'Copy Listing',
    description:
      'Paste an Etsy listing URL from your selected account to create a draft in the same shop with all details (title, description, tags, images, variations, personalisation) copied from that listing.',
  },
  [HelpTutorialEnum.SHOW_JOB_LIST]: {
    title: 'Show Job List',
    description:
      'Show Job List is a feature that allows you to see the list of jobs that are running in the background or have finished. Should there be any errors, they will be shown here.',
  },
  [HelpTutorialEnum.ETSY_LINK_ACCOUNT]: {
    title: 'Link Etsy Account',
    description:
      'Link your Etsy account to Crafty Smile. This will allow you to use the features that require Etsy account.',
    videoUrl: 'https://youtu.be/M50HEIuxj6c',
  },
  [HelpTutorialEnum.ETSY_CREATE_TEMPLATE]: {
    title: 'What is a template?',
    description:
      "A template is draft listing on Etsy. It is a pre-filled listing details that you can use to create a new listing. You can create a template from a listing you already have, or you can create a template from scratch. Just make sure the title of the listing starts with 'template'",
    videoUrl: 'https://youtu.be/z6T-87USoO0',
  },
  [HelpTutorialEnum.GDRIVE_CREATE_SHARE_LINK]: {
    title: 'What is a shared link?',
    description:
      'A shared link is a link to a folder in your google drive. It is a link that you can share with anyone. They can see the folder and the files in the folder.',
    videoUrl: 'https://youtu.be/TywFsZ4SRz0',
  },
};
